export class MataPelajaran {
  id: number;
  jenjang: string;
  mata_pelajaran: string;
  created_at: string;
  updated_at: string;

  constructor(
    id: number,
    jenjang: string,
    mata_pelajaran: string,
    created_at: string,
    updated_at: string
  ) {
    this.id = id;
    this.jenjang = jenjang;
    this.mata_pelajaran = mata_pelajaran;
    this.created_at = created_at;
    this.updated_at = updated_at;
  }
}
